import quizIconBlueNP from 'assets/icons/quiz-icon-blue-noplus.svg';

import './QuizSubHeader.scoped.scss';

interface QuizSubTitleProps {
  title?: string;
  loading?: boolean;
}

const QuizSubTitle: React.FC<QuizSubTitleProps> = ({ title, loading }) => {
  return (
    <div className="quiz-subtitle" style={{ filter: loading ? 'blur(4px)' : '' }}>
      <img
        alt="Quiz page logo blue"
        className="quiz-page-logo"
        src={quizIconBlueNP}
        width="30"
        height="30"
      />
      <h4>{title}</h4>
    </div>
  );
};

export default QuizSubTitle;
